

























































































import { Component, Vue } from 'vue-property-decorator';
import { User, Organisation } from '@/models/User';
import { BModal, BButton, BOverlay, BFormInput } from 'bootstrap-vue';
import Jumbotron from '@/components/Jumbotron.vue';
import { mapGetters } from 'vuex';
import { helpers, required, email, sameAs, minLength, requiredIf } from 'vuelidate/lib/validators';
import ModalAccountRemove from '@/components/modals/AccountRemove.vue';

@Component({
    name: 'Profile',
    components: {
        'jumbotron': Jumbotron,
        'b-modal': BModal,
        'b-button': BButton,
        'b-overlay': BOverlay,
        'b-form-input': BFormInput,
        'modal-account-remove': ModalAccountRemove,
    },
    computed: mapGetters({
        account: 'account/account',
        organisation: 'organisation/organisation',
    }),
})
export default class Profile extends Vue {
    // view models
    firstName = '';
    lastName = '';
    email = '';
    phoneNumber = '';
    newPassword = '';
    newPasswordCheck = '';

    // getters
    account!: User;
    organisation!: Organisation;

    // others
    error = '';
    updating = false;

    mounted() {
        this.reset();
    }

    reset() {
        this.error = '';
        this.firstName = this.account.firstName;
        this.lastName = this.account.lastName;
        this.email = this.account.email;
        this.phoneNumber = this.account.phoneNumber;
        this.newPassword = '';
        this.newPasswordCheck = '';
        this.updating = false;
        this.$v.$reset();
    }

    validations() {
        return {
            firstName: {
                required,
                minLength: minLength(2),
            },
            lastName: {
                required,
                minLength: minLength(2),
            },
            email: {
                required,
                email,
                minLength: minLength(3),
            },
            phoneNumber: {
                minLength: minLength(10),
            },
            newPassword: {
                required: requiredIf((value: string) => {
                    return !this.account.id && helpers.req(value);
                }),
                minLength: minLength(6),
            },
            newPasswordCheck: {
                sameAsPassword: sameAs('newPassword'),
            },
        };
    }

    async updateAccount() {
        this.updating = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
            return;
        }
        try {
            const r = await this.$store.dispatch('users/update', {
                id: this.account.id,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phoneNumber: this.phoneNumber,
                plainPassword: this.newPassword,
            });

            if (r.response && r.response.status === 401) {
                throw new Error('Account update failed. Renew token.');
            }
        } catch (error) {
            this.error = 'Account update failed.';
        } finally {
            this.updating = false;
        }
    }
}
